import { explorerAddr, MAINNET, type ChainId } from '../lib/chain';

export function AddrLink({ addr, chainId = MAINNET, text }: { addr: string; chainId?: ChainId; text?: string }) {
  return <a href={explorerAddr(addr, chainId)} rel="noopener">{text ?? addr}</a>;
}
